import { Text, VStack } from "@chakra-ui/react";
import { MetaIdentityCatalogRefreshButton } from "./MetaIdentityCatalogRefreshButton";

type IdentityCatalogSelectNoOptionsProps = {
  inputValue: string;
  entityLabel: string;
  onRefresh?: () => void | Promise<void>;
  isRefreshing?: boolean;
};

/** Dropdown empty state for identity pickers when search misses or catalog is empty. */
export function IdentityCatalogSelectNoOptions({
  inputValue,
  entityLabel,
  onRefresh,
  isRefreshing = false,
}: IdentityCatalogSelectNoOptionsProps) {
  const query = inputValue.trim();

  return (
    <VStack align="stretch" spacing={3} py={3} px={3} w="full">
      <Text fontSize="sm" color="gray.600" textAlign="center" lineHeight="short">
        {query
          ? `No ${entityLabel} match "${query}".`
          : `No ${entityLabel} in your catalog yet.`}
      </Text>
      {query && onRefresh ? (
        <MetaIdentityCatalogRefreshButton
          onRefresh={onRefresh}
          isRefreshing={isRefreshing}
        />
      ) : null}
    </VStack>
  );
}
